// Module
var code = "<div class=\"loaderFocused\">\n        <div class=\"loaderContainer\">\n            <div class=\"loader curveDetailsLoader\"></div>\n            <h2 class=\"loaderText\" data-bind=\"text: loaderText\"></h2>\n        </div>\n</div>\n";
// Exports
module.exports = code;